import { TicketDetailForm } from '../DefinedFormTypes';
import React, { Fragment } from 'react';
import Divider from '../../../../components/Divider';
import FormSection from '../../../../components/FormSection';
import { Control, Controller, UseFormRegister } from 'react-hook-form';
import { GraniteLabel } from '../../../../components/V2/Label/GraniteLabel';
import RadioButton from '../../../../components/RadioButton';
import { GraniteInput } from '../../../../components/V2/Input/GraniteInput';
import { POTSCustomerLineForm } from './schemas';
import { StandardTools } from '../../../../components/StandardTools/StandardTools';
import PhoneNumberInput from '../../../../components/V2/Input/PhoneNumber';
import {
  FormWithContact,
  TicketDetailContactForm,
} from 'screens/LetUsHelp/BaseComponents/TicketDetailContactForm';
import { NonStandardToolsFieldTextField } from 'screens/LetUsHelp/BaseComponents/NonStandardToolsField';

export type POTSCustomerLineProps = TicketDetailForm<POTSCustomerLineForm>;

export const POTSCustomerLine = ({
  register,
  control,
  errors,
}: POTSCustomerLineProps) => {
  return (
    <Fragment>
      <FormSection title="Ticket details" gridClassName="grid-cols-2">
        <PhoneNumberInput
          name="POTSTelephoneNumber"
          control={control}
          label="Enter the telephone number (optional)"
          error={errors.POTSTelephoneNumber?.message}
          className="col-span-full"
          placeholder="(---) --- ----"
        />
        <GraniteInput
          label="Enter the MPOE (minimum point of entry) location (optional)"
          className="col-span-full"
          error={errors.mpoe?.message}
          {...register('mpoe')}
        />
        <GraniteInput
          label="What is the telephone number being used for?"
          className="col-span-full"
          error={errors.whatIsUsedFor?.message}
          {...register('whatIsUsedFor')}
        />
      </FormSection>
      <Divider />
      <FormSection gridClassName="grid-cols-2">
        <Controller
          control={control}
          name="techToTestWith"
          render={({ field: { onChange, value, ref } }) => (
            <Fragment>
              <GraniteLabel
                label="Does the technician need to test with anyone specific?"
                element="div"
                className="col-span-full"
              >
                <RadioButton
                  options={[
                    {
                      label: "Yes, I'll provide their contact information",
                      value: 'Yes',
                    },
                    { label: 'No', value: 'No' },
                  ]}
                  selectedValue={value?.techToTestWith}
                  error={errors.techToTestWith?.message}
                  onChange={(techToTestWith) =>
                    onChange({ ...value, techToTestWith })
                  }
                  ref={ref}
                />
              </GraniteLabel>
              {value?.techToTestWith && value.techToTestWith === 'Yes' && (
                <TicketDetailContactForm
                  errors={errors}
                  register={
                    register as unknown as UseFormRegister<FormWithContact>
                  }
                  control={control as unknown as Control<FormWithContact>}
                />
              )}
            </Fragment>
          )}
        />
      </FormSection>
      <Divider />
      <FormSection>
        <StandardTools />
        <NonStandardToolsFieldTextField control={control} />
      </FormSection>
    </Fragment>
  );
};
